module.exports = __webpack_public_path__ + "01_mid_brown.fb492fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_mid_brown.png
// module id = jkss
// module chunks = 0